import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Inject, inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/AuthService';
import { RestService } from 'src/app/services/RestService';
import { parseJwt } from 'src/app/utilities/all.helpers';

@UntilDestroy()
@Component({
    selector: 'signup',
    templateUrl: './signup.component.html',
    standalone: false,
})
export class SignUpComponent implements OnInit {
   
    @Input() password: string;
    @Input() firstname: string;
    @Input() lastname: string;
    @Input() email: string;
    @Input() login: string;
    public isPasswordVisible: boolean = false;
    public isAtLeastMedium!: boolean;
    public isPasswordValid: boolean = false;
    private passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[?!\/,;]).{8,}$/;
    userCredentials = {
        login: '',
        password: '',
    };

    constructor(
       private route: ActivatedRoute,
       @Inject(RestService) private restService: RestService,
       private notification: ToastrService,
       private router: Router,
       @Inject(AuthService) private authService: AuthService,
    ) {
        inject(BreakpointObserver)
        .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
        .pipe()
        .subscribe((result) => {
            const matches = result.matches;
            this.isAtLeastMedium = matches;
        });
    }

    async ngOnInit(): Promise<void> {
        try {
            const params = await firstValueFrom(this.route.params);
            const token = params['token'];
            const payload: any = parseJwt(token);

            const expirationDate = new Date(payload.exp * 1000);
            const now = new Date();

            if (expirationDate < now) {
                this.handleRedirection("Le lien a expiré. Veuillez recommencer la procédure.");
                return;
            }

            this.firstname = payload.surname;
            this.lastname = payload.name;
            this.email = payload.email;
            this.login = payload.login;

            this.userCredentials = {
                login: payload.login,
                password: payload.password,
            };

            const resetUserId = await this.authService.logIn(this.userCredentials);

            // if (resetUserId) {
            //     this.handleRedirection("Le compte a déjà été créé. Vous pouvez vous connecter avec vos identifiants.");
            // }

        } catch (error) {
            console.error('Erreur lors de l’initialisation du composant:', error);
        }
    }

    private handleRedirection(message: string): void {
        this.router.navigate(['/']);
        this.notification.error(message);
    }

    public onSubmit(): void {
        
        this.route.params.subscribe(async params => {
            const token = params['token'];
            const payload: any = parseJwt(token);
            const data = {
                id: payload.id,
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password,
                login: this.login,
            };
            try {

                await this.restService.signup(token, payload.id , data);
                this.notification.info(
                    "Compte correctement créé !",
                );
                this.router.navigate(['/']);

            } catch (error) {
                console.error('Error during signup:', error);
                this.notification.error(
                    "Une erreur s'est produite. Impossible d'afficher la liste des adresses.",
                );
            }
            
        });

    }

    public togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
    }

    validatePassword(): void {
        this.isPasswordValid = this.passwordRegex.test(this.password);
    }
}


